import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  const { t } = useTranslation('home');

  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Sweeping%20panoramic%20lifestyle%20photography%20of%20diverse%20fashion%20and%20lifestyle%20products%20artfully%20scattered%20across%20a%20warm%20textured%20terracotta%20tiled%20floor%20viewed%20from%20elevated%20angle%20soft%20golden%20hour%20sunlight%20streaming%20through%20large%20arched%20Mediterranean%20windows%20casting%20dramatic%20elongated%20shadows%20rich%20earthy%20sienna%20ochre%20and%20ivory%20tones%20sophisticated%20editorial%20catalog%20composition%20warm%20inviting%20atmosphere%20luxurious%20yet%20approachable%20mood&width=1600&height=900&seq=cta-bg-v7&orientation=landscape"
          alt="CSSBuy Spreadsheet CTA"
          title="Comece agora no CSSBuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 text-center px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-black text-background-50 uppercase tracking-wide mb-4 leading-tight">
          {t('cta_title')}
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-2">{t('cta_subtitle1')}</p>
        <p className="text-sm md:text-base text-background-50/80 mb-8">{t('cta_subtitle2')}</p>

        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 text-sm md:text-base font-bold rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer group"
        >
          <span className="w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-shopping-bag-line text-background-50 text-sm"></i>
          </span>
          <span>{t('cta_button')}</span>
          <span className="w-5 h-5 flex items-center justify-center group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform">
            <i className="ri-arrow-right-up-line text-background-50"></i>
          </span>
        </a>
      </div>
    </section>
  );
}